import InterestSelector from "./InterestSelector.vue";

export * from "./interestSelector.data";
export * from "./interestSelector.types";

export default InterestSelector;
